import React from "react";
import { useSelector } from "react-redux";
import { AlertTriangle } from "lucide-react";
import { builderSelectors } from "../../store/builderReducer";
import AgentStatusIndicator from "./AgentStatusIndicator";
import AgentTodoList from "./AgentTodoList";
import TokenUsageMeter from "./TokenUsageMeter";
import FileChangesTimeline from "./FileChangesTimeline";
import "./AgentExecutionPanel.scss";

/**
 * Container component that combines all agent UI elements
 * Shows status, todo list, file changes, and token usage
 */
const AgentExecutionPanel = () => {
  const agentSession = useSelector(builderSelectors.getAgentSession);
  const agentTodos = useSelector(builderSelectors.getAgentTodos);
  const agentCurrentTask = useSelector(builderSelectors.getAgentCurrentTask);
  const agentFileChanges = useSelector(builderSelectors.getAgentFileChanges);
  const agentTokenUsage = useSelector(builderSelectors.getAgentTokenUsage);
  const agentError = useSelector(builderSelectors.getAgentError);

  if (!agentSession) {
    return null;
  }

  return (
    <div className="agent-execution-panel">
      <AgentStatusIndicator status={agentSession.status} />

      {agentError && (
        <div className="agent-error">
          <AlertTriangle size={18} className="error-icon" />
          <span className="error-message">{agentError}</span>
        </div>
      )}

      <AgentTodoList todos={agentTodos} currentTask={agentCurrentTask} />

      <FileChangesTimeline changes={agentFileChanges} maxVisible={10} />
      {/*
      <TokenUsageMeter
        inputTokens={agentTokenUsage.inputTokens}
        outputTokens={agentTokenUsage.outputTokens}
        totalCost={agentTokenUsage.totalCost}
      />
      */}
    </div>
  );
};

export default AgentExecutionPanel;
